export default __webpack_public_path__ + "static/media/iranyekanwebregular.64099236.eot";